import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { Check } from "lucide-react";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import { getCities } from "../../actions/userActions/cityAction";
import { addVisitProfile, getVisitProfileDetail, updateVisitProfile } from "../../actions/userActions/VisitProfileAction";
import VisitlocationsRow from "./VisitlocationsRow";
import "./AddVisitprofile.css";
import {
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE,
  DEFAULT_SEARCH,
} from '../../Constatns';
import AddButton from "../subComponents/buttons/CustomAddButton";
import CancelButton from "../subComponents/buttons/CustomCancelButton";
import PrimaryButton from "../subComponents/buttons/PrimaryButton";
import Heading6Regular from "../designSystem/Heading6Regular";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import TextField from "../designSystem/TextField";
import SingleSelect from "../designSystem/SingleSelect";
import { validateFields } from "../../utils/Validations";
import { getEmployee } from "../../actions/userActions/employeeAction";
import { PERMISSIONS } from "../../Permissions";
import BackNavHeader  from "../subComponents/BreadCrumbs/BackNavHeader ";

import AddNewForm from "../addNew/AddNewForm";
import AddNewDrawer from "../addNew/AddNewDrawer";
import cityicon from "../../assets/images/cityIcon (2).svg";

import { t } from "../../locales/translate";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";

const AddVisitProfile = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const allCities = useSelector((state) => state.cities_reducer.cities);
  const addProfileStatus = useSelector((state) => state.visitProfile_reducer.addVisitProfile);
  const updateProfileStatus = useSelector((state) => state.visitProfile_reducer.updateVisitProfile);
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));
  const visitProfileData = useSelector(state => state.visitProfile_reducer.visitProfileDetail);
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.result[0]?.user?.id;
  
  const [systemGeneratedName, setSystemGeneratedName] = useState("");
  const employeeData = useSelector((state) => state.employees_reducer.employee);

  const initialValues = {
    visitProfileId: 0,
    name: "",
    city: "",
    rows: [{ visitLocationId: 0, practiceLocation: "", doctors: [] }],
  }; 
   const VISIT_PROFILE_STATE_KEY = 'visitProfileState';
  const VISIT_PROFILE_ADD_STATE_KEY = 'visitProfileAddState';
   const VISIT_PROFILE_PATH = '/admin/visitProfiles';
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
   const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerItem , setDrawerItem] = useState(null);
  useEffect(() => {
    dispatch(getEmployee(userId));
  }, [dispatch, userId]);
useEffect(() => {
  const saveState = () => {
      if (location.state?.fromVisitProfile || location.visitProfile) {
          sessionStorage.setItem(VISIT_PROFILE_STATE_KEY, JSON.stringify({
              page: location.state?.page || DEFAULT_PAGE,
              search: location.state?.search || DEFAULT_SEARCH,
              pageSize: location.state?.pageSize || DEFAULT_PAGE_SIZE
          }));
      }
  };
  
  window.addEventListener('beforeunload', saveState);
  
  if (!location.state?.fromVisitProfile && !location.visitProfile && sessionStorage.getItem(VISIT_PROFILE_STATE_KEY)) {
      try {
          const saved = JSON.parse(sessionStorage.getItem(VISIT_PROFILE_STATE_KEY));
          history.replace({
              ...location,
              state: {
                  fromVisitProfile: true,
                  page: saved.page,
                  search: saved.search,
                  pageSize: saved.pageSize
              }
          });
      } catch (e) {
          console.error("Error restoring state", e);
      }
  }
  
  return () => window.removeEventListener('beforeunload', saveState);
}, [location, history]);

// In the second useEffect
useEffect(() => {
  if (location.state && location.state.fromVisitProfile) {
      sessionStorage.setItem(VISIT_PROFILE_ADD_STATE_KEY, JSON.stringify({
          page: location.state.page || DEFAULT_PAGE,
          search: location.state.search || DEFAULT_SEARCH,
          pageSize: location.state.pageSize || DEFAULT_PAGE_SIZE
      }));
  }
}, [location.state]);

const navigateBack = () => {
  let page = DEFAULT_PAGE;
  let search = DEFAULT_SEARCH;
  let pageSize = DEFAULT_PAGE_SIZE;
  
  if (location.state && location.state.fromVisitProfile) {
      page = parseInt(location.state.page) || DEFAULT_PAGE;
      search = location.state.search || DEFAULT_SEARCH;
      pageSize = parseInt(location.state.pageSize) || DEFAULT_PAGE_SIZE;
  } else {
      try {
          const savedState = sessionStorage.getItem(VISIT_PROFILE_ADD_STATE_KEY);
          if (savedState) {
              const parsedState = JSON.parse(savedState);
              page = parseInt(parsedState.page) || DEFAULT_PAGE;
              search = parsedState.search || DEFAULT_SEARCH;
              pageSize = parseInt(parsedState.pageSize) || DEFAULT_PAGE_SIZE;
          }
      } catch (e) {
          console.error("Error retrieving state", e);
      }
  }

  const searchParams = new URLSearchParams();
  searchParams.set('page', page);
  searchParams.set('pageSize', pageSize);
  if (search) searchParams.set('search', search);
  
  history.push({
      pathname: VISIT_PROFILE_PATH,
      search: searchParams.toString() ? `?${searchParams.toString()}` : '',
      state: {
          returnToVisitProfile: true,
          page,
          search,
          pageSize
      }
  });
};
  useEffect(() => {
    if (location.visitProfile) {
      const profileRow = location.visitProfile.row;
      setFormValues({
        ...formValues,
        visitProfileId: profileRow.visitProfileId,
        name: profileRow.profileName,
        city: profileRow.cityId,
        rows: profileRow.visitLocations.map((loc) => ({
          visitLocationId: loc.visitLocationId,
          practiceLocation: loc.practiceLocationId,
          doctors: loc.doctorIds,
        })),
      });

      setSystemGeneratedName(
        typeof profileRow.systemGeneratedName === "string" ? profileRow.systemGeneratedName : ""
      );
    } else {
      setSystemGeneratedName(
     typeof employeeData?.systemGeneratedProfileName === "string"
          ? employeeData.systemGeneratedProfileName
          : ""
      );
    }
  }, [location.visitProfile, employeeData]);
  useEffect(() => {
    dispatch(getCities({ filter: { countryId: "1" }, pageNumber: -1, pageSize: 0 }));
  }, [dispatch]);
  useEffect(() => {
    if (formValues.city) {
      dispatch(getVisitProfileDetail({ cityId: formValues.city }));
    }
  }, [dispatch, formValues.city]);
const getOptions = () => {
   return (
      allCities !== "isLoading" &&
      allCities.length !== 0 &&
      allCities.result?.[0]?.cities?.length !== 0 &&
      allCities.result[0].cities
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((city) => ({
          value: city.id,
          label: city.name
        }))
    ) || [];
};

  // Form value handlers
  const handleChange = (name, value) => {
    setFormValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

   const handleAddNew = (itemName) => {
  setDrawerItem(itemName);
  setDrawerOpen(true);
};

  const handleTextChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleCityChange = (event) => {
    setFormValues({
      ...formValues,
      city: event.value
    });
  };

  // Row management
  const handleAddRow = () => {
    setFormValues((prevState) => ({
      ...prevState,
      rows: [
        ...prevState.rows,
        { visitLocationId: 0, practiceLocation: "", doctors: [] },
      ],
    }));
  };

  const handleRemoveRow = (rowIndex) => {
    setFormValues((prevState) => ({
      ...prevState,
      rows: prevState.rows.filter((_, index) => index !== rowIndex),
    }));
  };
  const handleSubmit = () => {
    const errors = validateFields(formValues, 'visitProfile');
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const visitProfileData = {
        visitProfileId: formValues.visitProfileId,
        profileName: formValues.name,
        cityId: formValues.city,
        visitLocations: formValues.rows.map((row) => ({
          visitLocationId: row.visitLocationId,
          practiceLocationId: row.practiceLocation,
          doctorIds: row.doctors,
        })),
      };
      if (location.visitProfile) {
        dispatch(updateVisitProfile(visitProfileData))
          .then(navigateBack);
      } else {
        dispatch(addVisitProfile(visitProfileData))
          .then(navigateBack);
      }
    }
  };
 const handleGoBack = () => {
    navigateBack();
  };
  return (
    <>
      {/* Redirects for completed operations or permission checks */}
      {addProfileStatus && addProfileStatus !== "isLoading" && <Redirect to="/admin/visitProfiles" />}
      {updateProfileStatus && updateProfileStatus !== "isLoading" && <Redirect to="/admin/visitProfiles" />}
      {!permissions.includes(PERMISSIONS.CAN_ADD_VISIT_PROFILE) &&
        !permissions.includes(PERMISSIONS.CAN_UPDATE_VISIT_PROFILE) && <Redirect to="/admin" />}
      {!location.id && <Redirect to={"/admin/AddVisitProfile"} />}
      <div className="add-visit-profile-container">
        <LoadingOverlay isVisible={allCities === "isLoading"} />
      <BackNavHeader text={t("addVisitProfile")} onBack={handleGoBack} />
        <div className="add-content-wrapper">
          <div className="row">
            <div className="col-4">
              <TextField
                name="systemGeneratedName"
                label={t("name")}
                type="text"
                disabled
                value={systemGeneratedName}
                placeholder=""
              />
            </div>
            <div className="col-4">
              <TextField
                name="name"
                label= {`${t("displayName")} *`}
                type='text'
                value={formValues.name}
                onChange={handleTextChange}
                placeholder={t("displayName")}
                error={formErrors.name}
              />
            </div>
            <div className="col-4">
              <SingleSelect
                label= {`${t("city")} *`}
                isSearchable
                secondaryLabel
                iconEnd
                error={formErrors.city}
                disabled={!!location.visitProfile?.row.cityId}
                onChange={handleCityChange}
                value={formValues.city}
                placeholder={t("city")}
                options={getOptions()}
                configKey={"city"}
                onAddNewClick={() => handleAddNew("city")}
              />
            </div>
          </div>

          <hr />

          <div className="add-visit-profile-row-container">
            {formValues.rows.map((row, index) => (
              <VisitlocationsRow
                key={index}
                row={row}
                index={index}
                formValues={formValues}
                visitProfileData={visitProfileData}
                formErrors={formErrors}
                setFormValues={setFormValues}
                setFormErrors={setFormErrors}
                handleRemoveRow={handleRemoveRow}
              />
            ))}
            <div className="add-visit-profile-form-actions-left">
              <AddButton
                onClick={handleAddRow}
                text={t("addAnother")}
              />
            </div>
          </div>

          <hr />

          <div className="add-visit-profile-form-actions">
            <CancelButton onClick={handleGoBack} text={t("cancel")} width={document.body.dir === "rtl" ? "119px" : ""}/>
            <PrimaryButton
              onClick={handleSubmit}
              isLoading={addProfileStatus === "isLoading" || updateProfileStatus === "isLoading"}
              text={location.visitProfile ? `${t("update")}` : `${t("save")}` }
              icon={Check}
             width={location.visitProfile ? "95px" : document.body.dir === "rtl" ? "123px" : ""}
            />
          </div>
        </div>
      </div>
      <AddNewDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
         title={drawerItem? t("addItem").replace(/{{item}}/g, t(drawerItem)): ""}
          subtext={drawerItem ? t("createNewItemRecord").replace(/{{item}}/g, t(drawerItem)) : ""}
          icon={drawerItem  === "city" ? <img src={cityicon} alt={drawerItem } /> : null}
        >
          {drawerItem  && (
           <AddNewForm
              itemName={drawerItem }
              onClose={() => setDrawerOpen(false)}
              onSave={(newCity) => {
                if (drawerItem  === "city") {
                  dispatch(getCities(cityBody)).then(() => {
                    setFormValues((prev) => ({
                      ...prev,
                      cityId: newCity.id,
                      cityName: newCity.name
                    }));
                  });
                }
              }}
            />

          )}
</AddNewDrawer>
    </>
  );
};

export default AddVisitProfile;